export const getUserEstablishmentIds = (userData) => {
  if (!userData) return [];

  if (Array.isArray(userData.establishmentIds)) {
    return userData.establishmentIds.filter(Boolean);
  }

  if (Array.isArray(userData.establishments)) {
    return userData.establishments
      .map(item => typeof item === 'string' ? item : item?.id || item?.establishmentId)
      .filter(Boolean);
  }

  const currentCompany = Array.isArray(userData.companies)
    ? userData.companies.find(company => company.companyId === userData.currentCompanyId || company.id === userData.currentCompanyId)
    : null;

  if (Array.isArray(currentCompany?.establishmentIds)) {
    return currentCompany.establishmentIds.filter(Boolean);
  }

  if (Array.isArray(currentCompany?.establishments)) {
    return currentCompany.establishments
      .map(item => typeof item === 'string' ? item : item?.id || item?.establishmentId)
      .filter(Boolean);
  }

  return [];
};

export const canAccessAllEstablishments = (userData) => {
  return ['root', 'admin', 'operational'].includes(userData?.role);
};

export const filterEstablishmentsForUser = (establishments, userData) => {
  if (canAccessAllEstablishments(userData)) return establishments;
  const allowedIds = getUserEstablishmentIds(userData);
  return establishments.filter(establishment => allowedIds.includes(establishment.id));
};
